var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-container custom-scrollbar",style:({'max-height' : _vm.maxHeight ? _vm.maxHeight : '25vh'}),attrs:{"id":_vm.id}},[_c('s-card',{staticClass:"stretch-self",attrs:{"padding":_vm.padding}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }